<template>
  <div class="content">
     <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back.png')"
      />
    <van-popup v-model="show" round>
      <div class="pop1">
        <div style="background: #fff; padding-top: 24px">
          <div class="pop-title">提交成功</div>
          <div class="pop-exc">
            提现申请已提交，3个工作日内完成审核，审核通过后，将自动转入您的微信零钱，请注意查收
          </div>
        </div>

        <div class="popFt">
          <van-button type="warning" @click="show = false" class="popbtn"
            >确认</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="show = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show1" round>
      <div class="pop1">
        <div style="background: #fff; padding-top: 24px">
          <div class="pop-title">什么是待结算金额</div>
          <div class="pop-exc">
            用户分销成功后产生的收益计入待结算金额，15天内用户参与分销的订单未发生退款情况，15天后此笔分销提成计入可提现金额。
          </div>
        </div>

        <div class="popFt">
          <van-button type="warning" @click="show1 = false" class="popbtn"
            >我已知晓</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="show1 = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show2" style="top: 7.5rem" @close="close2()" round>
      <div class="pop" style="padding: 37px 28px">
        <div
          style="
            padding-bottom: 27px;
            background: #fff;
            border-radius: 35px;
            padding: 15px;
          "
        >
          <img
            v-lazy="showPop.gzh"
            style="width: 6.8rem; height: auto"
            class="pop-img"
          />
        </div>
      </div>
      <div style="text-align: center">
        <img
          style="height: 30px; width: 30px; margin: 28px auto"
          @click="show2 = false"
          class="closeImg"
          v-lazy="closeImg"
        />
      </div>
    </van-popup>
    <van-popup v-model="showEr" style="top: 7.5rem" @close="closeEr()" round>
      <div class="pop" style="padding: 37px 28px">
        <div
          style="
            padding-bottom: 27px;
            background: #fff;
            border-radius: 35px;
            padding: 15px;
          "
        >
          <img
            v-lazy="showPop.image"
            style="width: 6.8rem; height: auto"
            class="pop-img"
          />
          <div style="text-align: center">识别二维码，添加客服微信</div>
        </div>
      </div>
      <div style="text-align: center">
        <img
          style="height: 30px; width: 30px; margin: 28px auto"
          @click="showEr = false"
          class="closeImg"
          v-lazy="closeImg"
        />
      </div>
    </van-popup>
    <div class="head">
      <div
        @click.stop="openEr()"
        style="
          position: absolute;
          right: 12px;
          top: 10px;
          font-size: 13px;
          z-index: 100;
          color: #fff;
          border-radius: 5px;
          padding: 3px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        "
      >
        <img
          style="
            height: 24px;
            width: 24px;
            vertical-align: middle;
            margin-top: -2px;
          "
          v-lazy="require('./../../../assets/img/test/kefu.png')"
        />
        <div style="display: inline-block; margin-left: 5px">提现咨询</div>
      </div>
      <div class="t1">我的余额 (元)</div>
      <div class="t2">{{ number }}</div>
    </div>
    <div class="c1">
      <div @click="payType = 1" :class="payType == 2 ? 'check1' : 'check2'">
        <img
          style="
            margin-left: -10px;
            height: 18px;
            width: 20px;
            vertical-align: middle;
            margin-top: -2px;
            margin-right: 10px;
          "
          v-lazy="require('./../../../assets/img/test/wechat.png')"
        />微信提现
      </div>
      <div @click="payType = 2" :class="payType == 2 ? 'check2' : 'check1'">
        <img
          style="
            margin-left: -10px;
            height: 19px;
            width: 19px;
            vertical-align: middle;
            margin-top: -2px;
            margin-right: 10px;
          "
          src="https://t.alipayobjects.com/tfscom/T1Z5XfXdxmXXXXXXXX.png"
        />支付宝提现
      </div>
    </div>
    <div class="c2">每人每日仅可提交<span>1次</span>提现申请</div>
    <div class="c3">提现金额</div>
    <div class="c4">
      ￥<input
        v-model="much"
        @input="checkInput"
        @blur="inputBlur"
        placeholder="请输入提现金额，最少1元"
      />
    </div>
    <div class="c5">
      当前可提现金额{{ number }}元，<span @click="all">全部提现</span>
    </div>
    <div class="c6">
      待结算金额{{ info.to_settle }}元
      <img
        @click="show1 = true"
        style="
          height: 13px;
          width: 13px;
          vertical-align: middle;
          margin-top: -2px;
          margin-left: 3px;
        "
        v-lazy="require('./../../../assets/img/ghelp.png')"
      />
    </div>
    <div class="c7">收款方实名</div>
    <div class="c8">
      <input
        class="input"
        v-model="name"
        @blur="inputBlur"
        placeholder="请输入您微信实名认证的真实姓名"
      />
    </div>
    <div class="c9">
      <p>1. 每笔提现金额至少<span class="span">1元</span></p>
      <p>
        2. 每日账户提现上限为<span class="span">5万元</span>，超出请<span
          @click.stop="openEr()"
          >联系客服</span
        >
      </p>
      <p>3. 为保证您的资金安全，提现申请需要实名认证</p>
      <p>4. 提现申请平台处理后，将直接转入您的微信钱包</p>
      <p>5. 0-9点是系统升级时间，暂时关闭提现功能</p>
      <p>6. 如需帮助请<span @click.stop="openEr()">联系客服</span></p>
    </div>
    <div @click="getMoney" :class="finish ? 'c10 c10-a' : 'c10'">提现</div>
  </div>
</template>

<script>
import { getGold, goldInfo } from "@/http/api";
export default {
  name: "golddetail",
  data() {
    return {
      payType: 1,
      active: true,
      active1: true,
      logo: require("./../../../assets/img/logos.png"),
      old: "",
      much: "",
      number: 0,
      show: false,
      show1: false,
      name: "",
      showEr: false,
      show2: false,
      showPop: {
        image: require("./../../../assets/img/test/erweima.png"),
        gzh: require("./../../../assets/img/test/gzh.png"),
      },
      closeImg: require("./../../../assets/img/test/close.png"),
      info: {},
    };
  },
  computed: {
    finish: {
      get: function () {
        return this.name && this.much >= 1 ? true : false;
      },
    },
  },
  created() {
    this.getIn();
  },
  methods: {
    goHome() {
      this.$router.push("/my/myGold");
    },
    getIn() {
      goldInfo().then((res) => {
        this.info = res.data;
        this.number = res.data.to_cash;
      });
    },
    all() {
      this.much = this.number;
    },
    closeEr() {
      this.showEr = false;
    },
    openEr() {
      this.showEr = true;
    },
    // 进入主页
    checkInput(e) {
      const reg = /^\d+$|^\d+\.\d*?$/;
      if (reg.test(e.target.value) || !e.target.value) {
        this.old = e.target.value;
        console.log(111);
        if (e.target.value > this.number) {
          this.much = this.number;
        }
        // this.value = e.target.value
      } else {
        console.log(e.target.value);
        this.much = this.old;
      }
    },
    inputBlur() {
      // window.scroll(0, 0);
      setTimeout(() => {
        // alert(1);
        if (
          document.activeElement.tagName === "INPUT" ||
          document.activeElement.tagName === "TEXTAREA"
        ) {
          return;
        }
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // 判断iPhone|iPad|iPod|iOS
          this.valRes = "ios";
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // 判断Android
          this.valRes = "android";
        }
        // if (this.valRes === 'ios') {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        // }
        // document.activeElement.scrollIntoViewIfNeeded(true);
        // }
      }, 10);
    },
    getMoney() {
      if (!this.finish) {
        return;
      }
      goldInfo().then((res) => {
        console.log(1112);
        if (res.data.need_alert == "yes") {
          this.show2 = true;
          console.log(111);
          return;
        }
        if (res.data.today_cashed_time >= 1) {
          this.$message({
            message: "每日只能提现1次",
            type: "error",
          });
          console.log(111);
          return;
        }
        let param = {
          name: this.name,
          amount: parseInt(this.much * 100) / 100,
          payment_method: this.payType,
        };

        getGold(param).then((res) => {
          if (res.code == "SUCCESS") {
            this.$message({
              message: "提现申请发起成功！",
              type: "success",
            });
            this.getIn();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
}
input {
  outline-style: none;
  border: 1px solid #fff;
  border-bottom: 1px solid #ccc;
  border-radius: 3px;
  padding: 14px 14px;
  font-size: 20px;
  color: #000;
  width: calc(100vw - 120px);
}

.input {
  outline-style: none;
  border: 1px solid #fff;
  border-bottom: 1px solid #ccc;
  border-radius: 3px;
  padding: 6px 14px;
  font-size: 15px;
  color: #000;
  width: calc(100vw - 120px);
  margin-left: 20px;
}

.content {
  .head {
    height: 44vw;
    width: 100vw;
    background-image: url("./../../../assets/img/test/goldb.png");
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
    padding-top: 34px;
    position: relative;

    .t1 {
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
    }

    .t2 {
      font-size: 52px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #ffffff;
      margin-top: 22px;
    }
  }

  .c1 {
    display: flex;
    padding: 11px 18px;
    justify-content: space-between;
    text-align: center;

    div {
      width: 159px;
      height: 39px;
      line-height: 35px;
      background: #ffffff;
      border-radius: 5px;
      border: 2px solid #d1d1d6;
      font-size: 13px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #4a4a4a;
    }

    .check2 {
      background: #fff9f3;
      border-radius: 5px;
      border: 2px solid #f5a623;
      color: #4a4a4a;
    }
  }

  .c2 {
    padding: 0 18px;
    margin-top: -3px;
    font-size: 12px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #9b9b9b;

    span {
      color: #f5a623;
    }
  }

  .c3 {
    padding: 23px 15px;
    font-size: 15px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #000000;
  }

  .c4 {
    padding: 3px 19px;
    color: #9b9b9b;
    font-size: 20px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
  }

  .c5 {
    padding: 6px 19px;
    font-size: 13px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #000000;

    span {
      color: #42686e;
    }
  }

  .c6 {
    padding: 6px 19px;
    font-size: 13px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #000000;
  }

  .c7 {
    padding: 30px 15px;
    color: #9b9b9b;
    font-size: 20px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
  }

  .c8 {
    padding: 0 19px;
    margin-top: -8px;
    margin-bottom: 10px;
    font-size: 15px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #9b9b9b;
  }

  .c9 {
    padding: 15px 19px;
    font-size: 12px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 20px;

    span {
      color: #42686e;
    }

    .span {
      color: #f5a623;
    }
  }

  .c10 {
    width: calc(100vw - 38px);
    margin: 0 19px;
    height: 45px;
    line-height: 45px;
    background: #f2f2f3;
    border-radius: 18px;
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4a4a4a;
    text-align: center;
    margin-bottom: 15px;
  }

  .c10-a {
    color: #fff;
    background: #42686e;
  }
}

.pop1 {
  margin-top: -17px;
  border-radius: 24px;
  width: 8.14rem;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  // .pop-img1 {

  //     // border-radius: 0.5rem;
  // }

  .pop-title {
    text-align: center;
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4a4a4a;
    padding-bottom: 23px;
    padding: 33px;
    background: #fff;
  }

  .pop-exc {
    padding: 0 27px;
    text-align: center;
    font-size: 15px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    // line-height: 0.41rem;
    letter-spacing: 1px;
    background: #fff;
    padding-bottom: 75px;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;
    padding-bottom: 44px;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .closeImg {
    height: 30px;
    width: 30px;
    margin: 0 auto;
  }

  .popFt {
    text-align: center;
    margin-top: -34px;

    margin-bottom: 20px;

    .popbtn {
      width: 80%;
      background-color: #42686e;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
      border: none;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .reduce {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .reduce-1 {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce-1.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .number {
    vertical-align: super;
    margin-top: -10px;
    display: inline-block;
    padding: 5px;
  }

  .add {
    display: inline-block;
    background: url("./../../../assets/img/test/add.jpg") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  img {
    width: 8.8rem;
    height: 7rem;
    border-radius: 0.5rem;
  }

  .code {
    margin: 10px auto 0;
    text-align: center;
    font-weight: bold;
    line-height: 47px;
    letter-spacing: 1.33px;
    .w(237);
    height: 47px;
    background-color: #eceff5;
    border-radius: 18px;
    font-size: 24px;
    font-weight: bold;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}
</style>
